// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"ad123a37","310":"bed9e99c","423":"741d21f0","626":"5ffdbd87","732":"930be875","767":"e4f713e1","785":"392646bd","835":"28c2218c","911":"c058e7ba"}[chunkId] + ".chunk.js";
};